
  $('.btn-sleep').click(function(){
    $("#sec-tabs").css("background","linear-gradient(180deg, #53A89B 19.79%, #5CC1B2 100%)");
    $("#sec-tabs .tabcontent-cus h1").css("color","#246963");
    $("#sec-tabs .tabcontent-cus p span").css("color","#246963");

    $("#sec-tabs .tabcontent-cus").css("opacity","0");
    $("#sec-tabs .tabcontent-cus.type-sleep").css("opacity","1");
  });

  $('.btn-daily').click(function(){
    $("#sec-tabs").css("background","linear-gradient(180deg, #C377E7 0%, #7D09B5 100%)");
    $("#sec-tabs .tabcontent-cus h1").css("color","#64018E");
    $("#sec-tabs .tabcontent-cus p span").css("color","#64018E");

    $("#sec-tabs .tabcontent-cus").css("opacity","0");
    $("#sec-tabs .tabcontent-cus.type-daily").css("opacity","1");
  });

  $('.btn-energy').click(function(){
    $("#sec-tabs").css("background","linear-gradient(180deg, #CFD800 0%, #009838 100%)");
    $("#sec-tabs .tabcontent-cus h1").css("color","#007B3A");
    $("#sec-tabs .tabcontent-cus p span").css("color","#007B3A");

    $("#sec-tabs .tabcontent-cus").css("opacity","0");
    $("#sec-tabs .tabcontent-cus.type-energy").css("opacity","1");
  });     

  $('.btn-skinny').click(function(){
    $("#sec-tabs").css("background","linear-gradient(180deg, #FF9124 19.79%, #FDA93B 100%)");
    $("#sec-tabs .tabcontent-cus h1").css("color","#FFB246");
    $("#sec-tabs .tabcontent-cus p span").css("color","#FFB246");

    $("#sec-tabs .tabcontent-cus").css("opacity","0");
    $("#sec-tabs .tabcontent-cus.type-skinny").css("opacity","1");
  });

  $('.btn-cold').click(function(){
    $("#sec-tabs").css("background","linear-gradient(180deg, #003882 19.79%, #005186 100%)");
    $("#sec-tabs .tabcontent-cus h1").css("color","#0782C0");
    $("#sec-tabs .tabcontent-cus p span").css("color","#0782C0");

    $("#sec-tabs .tabcontent-cus").css("opacity","0");
    $("#sec-tabs .tabcontent-cus.type-cold").css("opacity","1");
  });

  $('.btn-sunny').click(function(){
    $("#sec-tabs").css("background","linear-gradient(180deg, #A9AF15 19.79%, #DBC206 100%)");
    $("#sec-tabs .tabcontent-cus h1").css("color","#D7DF21");
    $("#sec-tabs .tabcontent-cus p span").css("color","#D7DF21");

    $("#sec-tabs .tabcontent-cus").css("opacity","0");
    $("#sec-tabs .tabcontent-cus.type-sunny").css("opacity","1");
  });